import { Link } from 'react-router-dom';
import { homepageArticles } from '@/mocks/articleData';

export default function ArticleCardsSection() {
  return (
    <section id="articles" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            Vigorbuy Spreadsheet Guides & Resources
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[650px] mx-auto">
            Explore our collection of in-depth shopping guides covering every product category. Each guide is packed with practical tips, QC insights and comparison strategies.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {homepageArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              onClick={() => window.scrollTo(0, 0)}
              className="group block bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden hover:border-primary-200/60 transition-all duration-300"
            >
              <div className="relative overflow-hidden aspect-[16/10]">
                <img
                  src={article.cardImageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-background-50/90 backdrop-blur-sm text-primary-600 rounded-full text-[11px] font-semibold">
                    {article.badge}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 mb-2.5 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {article.cardExcerpt}
                </p>
                <div className="flex items-center gap-3 text-[11px] text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line text-[10px]"></i>
                    {article.readTime}
                  </span>
                  <span className="flex items-center gap-1 text-primary-500 font-medium">
                    Read More
                    <i className="ri-arrow-right-line text-[10px] group-hover:translate-x-0.5 transition-transform"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}